module.exports = __webpack_public_path__ + "img/TON.8cf79efc.svg";